import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 3em;
  font-size: 0.9rem;
`
